import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

export interface CanComponentDeactivate {
	deactivateAcceptLabel: string;
	deactivateRejectLabel: string;
	deactivateHeader: string;
	deactivateMessage: string;

	canDeactivate: () => Observable<boolean> | boolean;
	acceptAction: () => void;
	rejectAction: () => void;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
	const confirmationService = inject(ConfirmationService);

	if (!component || component.canDeactivate()) {
		return of(true);
	}

	return new Observable<boolean>((observer) => {
		confirmationService.confirm({
			header: component.deactivateHeader,
			message: component.deactivateMessage,
			accept: () => {
				component.acceptAction();
				observer.next(true);
			},
			reject: () => {
				component.rejectAction();
				observer.next(true);
			},
			acceptLabel: component.deactivateAcceptLabel,
			icon: 'pi pi-exclamation-triangle',
			rejectLabel: component.deactivateRejectLabel,
			blockScroll: true
		});
	});
};